"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExportNotificationTitle = exports.ExportNotificationContent = void 0;
var theme_1 = require("../../components/theme");
var i18n_1 = require("../../i18n");
var mithril_1 = require("../../mithril");
var export_notification_detail_1 = require("./export.notification.detail/export.notification.detail");
var export_notification_detail_ctrl_1 = require("./export.notification.detail/export.notification.detail.ctrl");
var export_notification_style_1 = require("./export.notification.style");
(0, theme_1.addStyles)(export_notification_style_1.Style);
function viewNotificationDetail(notificationEntries, collection) {
    return notificationEntries.map(function (notificationEntry) {
        var detailCtrl = new export_notification_detail_ctrl_1.ExportNotificationDetailCtrl(notificationEntry, collection);
        return export_notification_detail_1.ExportNotificationDetail.view(detailCtrl);
    });
}
function viewContent(ctrl) {
    var children = ctrl.notifications
        .map(function (notification) {
        var revision = notification.revision;
        var collection = ctrl.getCollection(revision);
        var entries = ctrl.errors ? notification.errors : notification.warnings;
        return (0, mithril_1.m)('div', { className: export_notification_style_1.CSS.section }, [
            (0, mithril_1.m)('span', ctrl.getTitleFieldName(revision) + ': '),
            (0, mithril_1.m)('span', { className: export_notification_style_1.CSS.title }, collection.title),
            (0, mithril_1.m)('ul', { className: export_notification_style_1.CSS.content }, viewNotificationDetail(entries, collection))
        ]);
    });
    return (0, mithril_1.m)('div', { className: export_notification_style_1.CSS.container }, children);
}
function viewTitle(ctrl) {
    return ctrl.errors ? (0, i18n_1.Translate)(i18n_1.T.NOTIFICATION_ERROR_TITLE) : (0, i18n_1.Translate)(i18n_1.T.NOTIFICATION_WARNING_TITLE);
}
exports.ExportNotificationContent = { view: viewContent };
exports.ExportNotificationTitle = { view: viewTitle };
//# sourceMappingURL=export.notification.js.map